import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "row justify-content-center" };
const _hoisted_2 = { class: "col-md-10 col-lg-8 col-xl-9 col-xxl-8 col-xxxl-6" };
const _hoisted_3 = { class: "card mb-25 border-0 rounded-0 bg-white authentication-card" };
const _hoisted_4 = { class: "card-body letter-spacing" };
const _hoisted_5 = { key: 0 };
const _hoisted_6 = { class: "form-group mb-15 mb-sm-20" };
const _hoisted_7 = ["disabled"];
const _hoisted_8 = { class: "text-center mt-15 mt-sm-20 mt-md-25" };
const _hoisted_9 = { key: 1 };
const _hoisted_10 = { class: "form-group mb-15 mb-sm-20" };
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20" };
const _hoisted_12 = { class: "form-group mb-15 mb-sm-20" };
const _hoisted_13 = {
    key: 0,
    class: "text-danger"
};
const _hoisted_14 = ["disabled"];
const _hoisted_15 = { class: "text-center mt-15 mt-sm-20 mt-md-25" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_LoaderComponent = _resolveComponent("LoaderComponent");
    const _component_router_link = _resolveComponent("router-link");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "logo-auth" }, null, -1)),
                    (_ctx.step === '1')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _cache[12] || (_cache[12] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, "Mot de passe oublié?", -1)),
                            _cache[13] || (_cache[13] = _createElementVNode("p", { class: "mb-0 fs-md-15 fs-lg-16 text-paragraph text-center sub-text" }, " Saisissez votre adresse e-mail ci-dessous et nous vous enverrons le mot de passe récupéré. ", -1)),
                            _createElementVNode("form", null, [
                                _createElementVNode("div", _hoisted_6, [
                                    _cache[10] || (_cache[10] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Votre adresse email ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "email",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validEmail(_ctx.userData.email) }]),
                                        placeholder: "e.g. adam127704@gmail.com",
                                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.userData.email) = $event)),
                                        onChange: _cache[1] || (_cache[1] = (event) => _ctx.handleInput(event, 'email')),
                                        required: ""
                                    }, null, 34), [
                                        [_vModelText, _ctx.userData.email]
                                    ])
                                ]),
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100 mt-4", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValidEmail }]),
                                        type: "button",
                                        disabled: !_ctx.isFormValidEmail,
                                        onClick: _cache[2] || (_cache[2] =
                                            //@ts-ignore
                                            (...args) => (_ctx.resetPasswordStepOne && _ctx.resetPasswordStepOne(...args)))
                                    }, " Reinitialiser ", 10, _hoisted_7)),
                                _createElementVNode("div", _hoisted_8, [
                                    _createVNode(_component_router_link, {
                                        to: "/",
                                        class: "link-btn text-decoration-none text-primary fw-medium fs-md-15 fs-lg-16 position-relative"
                                    }, {
                                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                _createElementVNode("i", { class: "ph-bold ph-arrow-left" }, null, -1),
                                                _createTextVNode(" Retour ", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    (_ctx.step === '2')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _cache[18] || (_cache[18] = _createElementVNode("h4", { class: "text-black fw-bold mb-0 text-center" }, "Réinitialiser votre mot de passe?", -1)),
                            _cache[19] || (_cache[19] = _createElementVNode("p", { class: "mb-0 fs-md-15 fs-lg-16 text-paragraph text-center sub-text" }, " Saisissez le code de réinitialisation ainsi que votre nouveau mot de passe. ", -1)),
                            _createElementVNode("form", null, [
                                _createElementVNode("div", _hoisted_10, [
                                    _cache[14] || (_cache[14] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Code de réinitialisation ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        inputmode: "numeric",
                                        pattern: "[0-9]{6}",
                                        maxlength: "6",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validCode(_ctx.userData.code) }]),
                                        placeholder: "Entrez le code à 6 chiffres",
                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.userData.code) = $event)),
                                        onChange: _cache[4] || (_cache[4] = (event) => _ctx.handleInput(event, 'code')),
                                        required: ""
                                    }, null, 34), [
                                        [_vModelText, _ctx.userData.code]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_11, [
                                    _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Nouveau mot de passe ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "password",
                                        class: _normalizeClass(["form-control shadow-none rounded-0 text-black", { 'is-valid': _ctx.validPassword(_ctx.userData.password) }]),
                                        placeholder: "e.g. e.g. ******",
                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.userData.password) = $event)),
                                        onChange: _cache[6] || (_cache[6] = (event) => _ctx.handleInput(event, 'password')),
                                        required: ""
                                    }, null, 34), [
                                        [_vModelText, _ctx.userData.password]
                                    ])
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    _cache[16] || (_cache[16] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, " Confirmer votre mot de passe ", -1)),
                                    _withDirectives(_createElementVNode("input", {
                                        type: "password",
                                        class: "form-control shadow-none rounded-0 text-black",
                                        placeholder: "e.g. ******",
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event) => ((_ctx.userData.confirmPassword) = $event)),
                                        onChange: _cache[8] || (_cache[8] = (event) => _ctx.handleInput(event, 'confirmPassword')),
                                        required: ""
                                    }, null, 544), [
                                        [_vModelText, _ctx.userData.confirmPassword]
                                    ]),
                                    (!_ctx.isConform(_ctx.userData.confirmPassword))
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Mot de passe incorrect."))
                                        : _createCommentVNode("", true)
                                ]),
                                (_ctx.isLoading)
                                    ? (_openBlock(), _createBlock(_component_LoaderComponent, { key: 0 }))
                                    : (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        class: _normalizeClass(["default-btn transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 bg-success d-block w-100 mt-4", { 'opacity-50 cursor-not-allowed': !_ctx.isFormValidPasswordReset }]),
                                        type: "button",
                                        disabled: !_ctx.isFormValidPasswordReset,
                                        onClick: _cache[9] || (_cache[9] =
                                            //@ts-ignore
                                            (...args) => (_ctx.resetPasswordStepTwo && _ctx.resetPasswordStepTwo(...args)))
                                    }, " Reinitialiser ", 10, _hoisted_14)),
                                _createElementVNode("div", _hoisted_15, [
                                    _createVNode(_component_router_link, {
                                        to: "/",
                                        class: "link-btn text-decoration-none text-primary fw-medium fs-md-15 fs-lg-16 position-relative"
                                    }, {
                                        default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                                                _createElementVNode("i", { class: "ph-bold ph-arrow-left" }, null, -1),
                                                _createTextVNode(" Retour ", -1)
                                            ]))]),
                                        _: 1
                                    })
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true)
                ])
            ])
        ])
    ]));
}
